module.exports = __webpack_public_path__ + "static/media/5.4de7cb2a.jpg";